import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-text",
  "use": "icon-text-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-text\">\r\n  <path d=\"M576 192H192v192h64V256h192v512h-64v64h256v-64h-64V256h192v128h64V192z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol